import { inject, Injectable } from '@angular/core';
import { AuthorizationService } from '@infodata-group/inf-commons';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CustomAuthorizationService extends AuthorizationService {
  public lastRoute: string;

  constructor() {
    const router = inject(Router);
    super();
    router.events
      .pipe(
        filter(
          (event) => event instanceof NavigationStart && event.url !== '/login',
        ),
      )
      .subscribe((event: NavigationStart) => {
        this.lastRoute = event.url;
      });
  }

  logout(sendToServer?: boolean, navigateTo?: string) {
    sessionStorage.setItem('routeAfterLogin', this.lastRoute);
    super.logout(sendToServer, navigateTo);
  }

  clear() {
    this.cookieService.clear(document.domain);
    localStorage.clear();
    this.settings.clear();
    this.isAuthenticated = false;
    this.user = null;
  }

  navigate() {
    const lastRoute = sessionStorage.getItem('routeAfterLogin');
    if (lastRoute) {
      this.saveRoute = lastRoute;
      sessionStorage.removeItem('routeAfterLogin');
    }
    super.navigate();
  }
}
